export class DoctorProvince {
  provinceName: string;
  status: boolean;
  id: number;
}
